import { render } from "./MiniWizardManagerGeneral.vue?vue&type=template&id=1cc435da"
import script from "./MiniWizardManagerGeneral.vue?vue&type=script&lang=js"
export * from "./MiniWizardManagerGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__